import { VImg } from 'vuetify/lib/components/VImg';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "d-flex flex-column align-center text-center" },
    [
      _c("div", { staticClass: "text-h6 mb-2" }, [
        _vm._v(
          "\n    По запросу «" +
            _vm._s(_vm.searchQuery) +
            "» ничего не нашлось\n  "
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "text-body-1 text-secondary--text" }, [
        _vm._v("\n    Проверьте, нет ли ошибки в запросе\n  "),
      ]),
      _vm._v(" "),
      _c(VImg, {
        attrs: {
          src: "/static/_v1/pd/pictures/find/nothing-found-by-search.svg",
          alt: "Ничего не найдено",
          "aspect-ratio": "1",
          "max-width": "300",
          "max-height": "300",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }